import { IconProps } from './IconProps';

export function ChevronLeftIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00007 12L8.00005 12.0001L8.70715 12.7001L8.70718 12.7L15.0711 19L15.7782 18.3L9.41428 12L15.7782 5.70001L15.0711 5L8.70718 11.3L8.70711 11.3L8 12L8.00007 12Z"
                fill="#66182A"
            />
        </svg>
    );
}
